'use strict'
var _interopRequireDefault = require('@babel/runtime/helpers/interopRequireDefault')
require('core-js/modules/es.array.slice')
require('core-js/modules/es.array.sort')
require('core-js/modules/es.function.name')
exports.__esModule = true
exports.default = void 0
var _createClass2 = _interopRequireDefault(require('@babel/runtime/helpers/createClass'))
var _defineProperty2 = _interopRequireDefault(require('@babel/runtime/helpers/defineProperty'))

var _misc = require('../misc')
var _func = require('../func')

/* eslint-disable class-methods-use-this */ var Inherent = /*#__PURE__*/ (function() {
  function Inherent(_ref) {
    var onChange = _ref.onChange
    ;(0, _defineProperty2.default)(this, '_str', null)
    ;(0, _defineProperty2.default)(this, '_val', [])
    ;(0, _defineProperty2.default)(this, 'onChange', function() {})
    ;(0, _defineProperty2.default)(this, 'name', '')
    this.onChange = onChange
  }
  var _proto = Inherent.prototype
  _proto.setFromStr = function setFromStr(s) {
    var str = this.validateStr(s)
    if (str === null) {
      this._str = null
      this._val = []
      return this
    }

    if (this._str === str) return this
    this._str = str
    this._val = this.parseStr(str)

    this.onChange(this.name)

    return this
  }
  _proto.setFromVal = function setFromVal(v) {
    var val = this.validateVal(v)
    if (val === null) {
      this._val = []
      this._str = null
      return this
    }

    val.sort(_func.sortCb_num)

    if ((0, _misc.isEqual)(this._val, val)) return this
    this._val = val
    this._str = this.stringify(val)

    this.onChange(this.name)

    return this
  }
  _proto.validateStr = function validateStr(s) {
    return s
  }

  // eslint-disable-next-line no-unused-vars
  _proto.parseStr = function parseStr(s) {
    return []
  }
  _proto.validateVal = function validateVal(v) {
    return v
  }

  // eslint-disable-next-line no-unused-vars
  _proto.stringify = function stringify(v) {
    return ''
  }
  ;(0, _createClass2.default)(Inherent, [
    {
      key: 'str',
      get: function get() {
        return this._str
      }
    },
    {
      key: 'val',
      get: function get() {
        return this._val.slice(0)
      }
    },
    {
      key: 'isAny',
      get: function get() {
        return this.val.length === 0
      }
    }
  ])
  return Inherent
})()
exports.default = Inherent



//////////////////
// WEBPACK FOOTER
// ./~/hlp/dist/TimingParser/inherent.js
// module id = 124
// module chunks = 0